
import Account from "@/models/Account";
import UserClass from "@/models/UserClass";
import Group from "@/models/Group";
import User from "@/models/User";
import SharedClass from "@/models/SharedClass";
import axios from "axios";
import VueApiQueryList from "@/models/lists/VueApiQueryList";

import { useDataModelStore } from "./dataModel";

const AccountClasses = new VueApiQueryList(function(id) {

    const accountId = id;

    if (!accountId) {
        throw new Error("no account");
    }
    let acc = new Account({ id: accountId });
    return new UserClass().for(acc);
});

const AccountGroups = new VueApiQueryList(function(id) {
    const accountId = id;

    if (!accountId) {
        throw new Error("no account");
    }

    let acc = new Account({ id: accountId });
    return new Group().for(acc);
});
const AccountUsers = new VueApiQueryList(function(id, context, extra) {
    const accountId = extra?.account_id;

    if (!accountId) {
        throw new Error("no account");
    }

    let acc = new Account({ id: accountId });

    switch(context){
        case "class": {
            let userClass = new UserClass({ id: id });
            return new User().for(acc, userClass);
        }
        case "group": {
            let group = new Group({ id: id });
            return new User().for(acc, group);
        }
        case "sharedclass": {
            return new User().for( new SharedClass({ id: id }));
        }
    }

    return new User().for(acc);
}, new User());


class ServiceList {
    constructor(type = null) {
        this.type = type;
    }

    async list({ id = null, config = null, extra = null }) {
        const accountId = extra?.account_id;

        if (!accountId) {
            throw new Error("no account");
        }

        const client = axios.create();

        // Add a request interceptor
        client.interceptors.request.use(
            requestConfig => requestConfig,
            requestError => {
                //Send request exception to error api

                return Promise.reject(requestError);
            }
        );

        // Add a response interceptor
        client.interceptors.response.use(
            response => response.data,
            error => {
                return Promise.reject(error);
            }
        );

        let response = null;
        let nextPageToken = null;
        do {
            let params = [];
            if (nextPageToken) {
                params.push("pageToken=" + encodeURIComponent(nextPageToken));
            }
            if (config) {
                params.push(
                    "config" + "=" + encodeURIComponent(JSON.stringify(config))
                );
            }

            let r = await client.get(
                "/internalapi/v1/accounts/" +
                    accountId +
                    "/identities/" +
                    id +
                    "/" +
                    this.type +
                    (params.length ? "?" + params.join("&") : "")
            );
            nextPageToken = r.meta.nextPageToken;
            if (!response) {
                response = r;
            } else {
                response.data = response.data.concat(r.data);
            }
        } while (nextPageToken);

        return response;
    }
}

const ServiceGroups = new ServiceList("servicegroups");
const ServiceUsers = new ServiceList("serviceusers");
const ServiceClasses = new ServiceList("serviceclasses");

export const useClassStore = useDataModelStore('class', AccountClasses);
export const useGroupStore = useDataModelStore('group', AccountGroups);
export const useUserStore = useDataModelStore('user', AccountUsers);
export const useSharedClassStore = useDataModelStore('sharedclass', SharedClass);

export const useServiceGroupStore = useDataModelStore('extGroup', ServiceGroups);
export const useServiceUserStore = useDataModelStore('extUser', ServiceUsers);
export const useServiceClassStore = useDataModelStore('extClass', ServiceClasses);
